// src/components/Dashboard/RoleDashboard/index.js
import React from "react";
import RoleDashboard from "./RoleDashboard";

export default RoleDashboard;
export { default as VSNTransfersAdapter } from "./VSNTransfersAdapter";

// Optional fixed-role wrappers (use in routes if you want explicit paths)
export const AgentRoleDashboard = () => <RoleDashboard role="agent" />;
export const ScoutRoleDashboard = () => <RoleDashboard role="scout" />;
export const ClubRoleDashboard = () => <RoleDashboard role="club" />;
